import { render, staticRenderFns } from "./Diagram.vue?vue&type=template&id=2e2e3580&scoped=true&"
import script from "./Diagram.vue?vue&type=script&lang=js&"
export * from "./Diagram.vue?vue&type=script&lang=js&"
import style0 from "./Diagram.vue?vue&type=style&index=0&id=2e2e3580&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2e3580",
  null
  
)

export default component.exports